import React from 'react';
import { Select } from 'antd';

const Option = Select.Option;

const fileTypes = ['all', '.jpg', '.png', '.pdf', '.mp4', '.mp3'];

export default ({ handleChange, value }) => (
	<Select
		defaultValue={fileTypes.includes(value) && value !== 'all' ? value : 'File Type'}
		onChange={handleChange}
		style={{ width: 150 }}
	>
		{fileTypes.map(type => (
			<Option key={type} value={type}>
				{type}
			</Option>
		))}
	</Select>
);
